import styled from 'styled-components';

import { Typography } from '@useblu/ocean-react';

import {
  colorBrandPrimaryPure,
  colorBrandPrimaryUp,
} from '@useblu/ocean-tokens/web/tokens';

export const Wrapper = styled.div`
  width: 100%;
  min-height: 124px;
  align-self: flex-end;
  background-color: ${colorBrandPrimaryPure};

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Copyright = styled(Typography).attrs(() => ({
  variant: 'caption',
}))`
  &&& {
    margin-top: 16px;
    color: ${colorBrandPrimaryUp};
  }
`;
